(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["images-highlights"] && !Shopify.designMode) return;
  try {
    
  class ImagesHighlights extends HTMLElement {
    constructor() {
      super();

      // Cache DOM
      this.highlightItemsArr = Array.from(this.querySelectorAll('[data-highlight-item]'));
      this.contentItemsArr = Array.from(this.querySelectorAll('[data-highlight-item-content]'));
      this.mobileItemsArr = Array.from(this.querySelectorAll('[data-highlight-item-content-mobile]'));
      this.buttonsArr = Array.from(this.querySelectorAll('button[id^="yv-item-"]'));
      this.navButtons = Array.from(this.querySelectorAll('[data-action="previous"], [data-action="next"]'));
      this.isMobile = window.matchMedia('(max-width: 767px)').matches;

      // State
      this.animationCount = 0;
      this.animationQueue = [];
      this.currentMobileIndex = 0;
      this.resizeHandler = null;
    }

    connectedCallback() {
      this.init();
      this.setupResizeListener();
    }

    disconnectedCallback() {
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
      }
    }

    waitForLayout(cb) {
      requestAnimationFrame(() => {
        requestAnimationFrame(cb);
      });
    }

    setupResizeListener() {
      this.resizeHandler = () => {
        const maxW = this.getDynamicMaxWidth();

        // Update desktop max-widths
        this.contentItemsArr.forEach(item => {
          const body = item.querySelector('.yv-images-highlights-body-inner');
          if (body) body.style.maxWidth = `${maxW}px`;
        });

        // Update mobile max-widths
        this.mobileItemsArr.forEach(item => {
          const body = item.querySelector('.yv-images-highlights-body-inner');
          if (body) body.style.maxWidth = '100%';
        });

        // ---- MODE SWITCH DETECTOR ----
        const nowMobile = window.matchMedia('(max-width: 767px)').matches;

        if (nowMobile !== this.isMobile) {
          this.isMobile = nowMobile;

          if (this.isMobile) {
            // ENTERING MOBILE MODE
            this.resetMobileState();
          } else {
            // ENTERING DESKTOP MODE
            this.resetDesktopState();
          }
        }
      };

      window.addEventListener('resize', this.resizeHandler);
    }

    resetMobileState() {
      const wrapper = this.querySelector('.yv-images-highlights-content-mobile');
      if (!wrapper) return;

      wrapper.style.transform = 'translateX(0)';
      this.currentMobileIndex = 0;

      // this.measureWhenVisible(wrapper, () => {
      //   this.initMobileFirstItem();
      // });
      this.measureWhenVisible(wrapper, () => {
        this.waitForLayout(() => {
          this.initMobileFirstItem();
        });
      });

    }

    resetDesktopState() {
      // Clear any mobile inline junk
      this.mobileItemsArr.forEach(item => {
        item.classList.remove('active');
        item.style.width = '';
        item.style.height = '';
      });

      const wrapper = this.querySelector('.yv-images-highlights-content-mobile');
      if (wrapper) {
        wrapper.style.transform = '';
      }
    }

    measureWhenVisible(el, cb) {
      if (!el) return;

      const check = () => {
        if (el.offsetParent !== null) {
          cb();
        } else {
          requestAnimationFrame(check);
        }
      };

      check();
    }

    /* ---------------- CORE UTILS ---------------- */
    startAnimation() {
      this.animationCount++;
    }

    endAnimation() {
      this.animationCount = Math.max(0, this.animationCount - 1);

      if (this.animationCount === 0 && this.animationQueue.length) {
        const next = this.animationQueue.shift();
        requestAnimationFrame(() => {
          if (next.type === 'activate') this.activateItem(next.buttonId);
          if (next.type === 'navigate') this.navigate(next.direction);
        });
      }
    }

    isAnimating() {
      return this.animationCount > 0;
    }

    queueOrRun(action) {
      if (this.isAnimating()) {
        this.animationQueue.push(action);
        return true;
      }
      return false;
    }

    /* ---------------- LAYOUT ---------------- */
    getDynamicMaxWidth() {
      const wrapper = this.querySelector('.yv-images-highlights-content-wrapper');

      if (!wrapper) {
        const available = window.innerWidth - 120;
        return Math.min(470, available);
      }

      const style = getComputedStyle(wrapper);
      const padding = (parseFloat(style.paddingLeft) || 0) +
                      (parseFloat(style.paddingRight) || 0);

      const available = window.innerWidth - padding - 20;
      return Math.min(470, Math.max(280, available));
    }

    setupResizeListener() {
      this.resizeHandler = () => {
        const maxW = this.getDynamicMaxWidth();

        this.contentItemsArr.forEach(item => {
          const body = item.querySelector('.yv-images-highlights-body-inner');
          if (body) body.style.maxWidth = `${maxW}px`;
        });

        this.mobileItemsArr.forEach(item => {
          const body = item.querySelector('.yv-images-highlights-body-inner');
          if (body) body.style.maxWidth = '100%';
        });
      };

      window.addEventListener('resize', this.resizeHandler);
    }

    /* ---------------- IMAGE ANIMATION ---------------- */

    animateImageActive(el) {
      this.startAnimation();

      const duration = 600;
      const start = performance.now();

      const from = { scale: 0.8333, x: 200, o: 0 };
      const to = { scale: 1, x: 0, o: 1 };

      el.style.visibility = 'visible';
      el.style.display = 'grid';
      el.style.transform = `matrix(${from.scale},0,0,${from.scale},${from.x},0)`;
      el.style.opacity = from.o;

      const ease = t => 1 - Math.pow(1 - t, 3);

      const frame = now => {
        const p = Math.min((now - start) / duration, 1);
        const e = ease(p);

        const scale = from.scale + (to.scale - from.scale) * e;
        const x = from.x + (to.x - from.x) * e;
        const o = from.o + (to.o - from.o) * e;

        el.style.transform = `matrix(${scale},0,0,${scale},${x},0)`;
        el.style.opacity = o;
        el.style.pointerEvents = p === 1 ? 'auto' : 'none';

        p < 1 ? requestAnimationFrame(frame) : this.endAnimation();
      };

      requestAnimationFrame(frame);
    }

    animateImageInactive(el) {
      this.startAnimation();

      const duration = 500;
      const start = performance.now();

      const from = { scale: 1, x: 0, o: 1 };
      const to = { scale: 0.8333, x: -200, o: 0 };

      const ease = t => t * t * t;

      const frame = now => {
        const p = Math.min((now - start) / duration, 1);
        const e = ease(p);

        const scale = from.scale + (to.scale - from.scale) * e;
        const x = from.x + (to.x - from.x) * e;
        const o = from.o + (to.o - from.o) * e;

        el.style.transform = `matrix(${scale},0,0,${scale},${x},0)`;
        el.style.opacity = o;
        el.style.pointerEvents = 'none';

        if (p < 1) {
          requestAnimationFrame(frame);
        } else {
          el.style.transform = '';
          el.style.opacity = '0';
          el.style.visibility = 'hidden';
          this.endAnimation();
        }
      };

      requestAnimationFrame(frame);
    }

    /* ---------------- CONTENT ANIMATION ---------------- */

    animateItem(item) {
      
      this.startAnimation();

      const body = item.querySelector('[data-highlight-body]');
      if (!body) {
        this.endAnimation();
        return;
      }

      const parent = body.parentElement;

      // SAVE INLINE STYLES (not computed, inline only — like your original)
      const originalStyles = {
        position: parent.style.position || '',
        opacity: parent.style.opacity || '',
        visibility: parent.style.visibility || '',
      };

      // FORCE VISIBLE FOR MEASURE
      parent.style.position = 'static';
      parent.style.opacity = '1';
      parent.style.visibility = 'visible';
      body.style.opacity = '1';
      body.style.visibility = 'visible';

      // MEASURE
      const bodyHeight = body.scrollHeight;

      const button = item.querySelector('button');
      const buttonHeight = button ? button.offsetHeight : 48;
      const buttonWidth = button ? button.offsetWidth : 0;

      const finalWidth = Math.max(
        this.getDynamicMaxWidth(),
        buttonWidth
      );

      // FULL RESTORE — NO SHORTCUTS
      parent.style.position = originalStyles.position;
      parent.style.opacity = originalStyles.opacity;
      parent.style.visibility = originalStyles.visibility;
      body.style.opacity = '';
      body.style.visibility = '';

      // RESET ACTIVE STATE LIKE YOUR ORIGINAL
      const wasActive = item.classList.contains('active');
      if (wasActive) item.classList.remove('active');

      item.style.width = `${buttonWidth}px`;
      item.style.height = `${buttonHeight}px`;

      if (wasActive) item.classList.add('active');

      const widthDiff = finalWidth - buttonWidth;
      const heightDiff = bodyHeight - buttonHeight;

      const duration = 600;
      const start = performance.now();

      const easeOut = t => 1 - Math.pow(1 - t, 3);

      const frame = now => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = easeOut(progress);

        const currentW = buttonWidth + widthDiff * eased;
        const currentH = buttonHeight + heightDiff * eased;

        item.style.width = `${currentW}px`;
        item.style.height = `${currentH}px`;

        if (progress < 1) {
          requestAnimationFrame(frame);
        } else {
          this.endAnimation();
        }
      };

      requestAnimationFrame(frame);
    }

 
    /* ---------------- ACTIVATION ---------------- */

    activateItemFINE(buttonId) {
      if (!buttonId) return;
      if (this.queueOrRun({ type: 'activate', buttonId })) return;

      this.highlightItemsArr.forEach(item => {
        const isActive = item.dataset.highlightItem === buttonId;
        const wasActive = item.classList.contains('active');

        if (isActive && !wasActive) {
          item.classList.add('active');
          this.animateImageActive(item);
        }

        if (!isActive && wasActive) {
          item.classList.remove('active');
          this.animateImageInactive(item);
        }
      });

      this.contentItemsArr.forEach(item => {
        const isActive = item.dataset.highlightItemContent === buttonId;

        if (isActive) {
          item.classList.add('active');
          const body = item.querySelector('.yv-images-highlights-body-inner');
          if (body) body.style.maxWidth = `${this.getDynamicMaxWidth()}px`;
          this.animateItem(item);
        }  else {
          this.startAnimation();

          const currentWidth = item.offsetWidth;
          const currentHeight = item.offsetHeight;

          const button = item.querySelector('button');
          const buttonHeight = button ? button.offsetHeight : 48;
          const buttonWidth = button ? button.offsetWidth : 0;

          const widthDiff = buttonWidth - currentWidth;
          const heightDiff = buttonHeight - currentHeight;

          const duration = 400;
          const start = performance.now();

          const easeInOut = t =>
            t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

          const frame = now => {
            const p = Math.min((now - start) / duration, 1);
            const e = easeInOut(p);

            item.style.width = `${currentWidth + widthDiff * e}px`;
            item.style.height = `${currentHeight + heightDiff * e}px`;

            if (p < 1) {
              requestAnimationFrame(frame);
            } else {
              item.classList.remove('active');
              item.style.width = '';
              item.style.height = '';
              this.endAnimation();
            }
          };

          requestAnimationFrame(frame);
        }

      });
    }

    activateItem(buttonId) {
      if (!buttonId) return;
      if (this.queueOrRun({ type: 'activate', buttonId })) return;

      this.highlightItemsArr.forEach(item => {
        const isActive = item.dataset.highlightItem === buttonId;
        const wasActive = item.classList.contains('active');

        if (isActive && !wasActive) {
          item.classList.add('active');
          this.animateImageActive(item);
        }

        if (!isActive && wasActive) {
          item.classList.remove('active');
          this.animateImageInactive(item);
        }
      });

      this.contentItemsArr.forEach(item => {
        const isActive = item.dataset.highlightItemContent === buttonId;

        if (isActive) {
          item.classList.add('active');

          const body = item.querySelector('.yv-images-highlights-body-inner');
          if (body) body.style.maxWidth = `${this.getDynamicMaxWidth()}px`;

          // force reflow
          item.offsetHeight;

          // start fade-in
          item.classList.add('animating');

          this.animateItem(item);
        } else {
          // start fade-out
          item.classList.remove('animating');

          this.startAnimation();

          const currentWidth = item.offsetWidth;
          const currentHeight = item.offsetHeight;

          const button = item.querySelector('button');
          const buttonHeight = button ? button.offsetHeight : 48;
          const buttonWidth = button ? button.offsetWidth : 0;

          const widthDiff = buttonWidth - currentWidth;
          const heightDiff = buttonHeight - currentHeight;

          const duration = 400;
          const start = performance.now();

          const easeInOut = t =>
            t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

          const frame = now => {
            const p = Math.min((now - start) / duration, 1);
            const e = easeInOut(p);

            item.style.width = `${currentWidth + widthDiff * e}px`;
            item.style.height = `${currentHeight + heightDiff * e}px`;

            if (p < 1) {
              requestAnimationFrame(frame);
            } else {
              item.classList.remove('active');
              item.style.width = '';
              item.style.height = '';
              this.endAnimation();
            }
          };

          requestAnimationFrame(frame);
        }
      });
    }


    /* ---------------- NAV ---------------- */

    navigate(direction) {
      if (this.queueOrRun({ type: 'navigate', direction })) return;

      const index = this.buttonsArr.findIndex(btn =>
        this.highlightItemsArr.some(item =>
          item.dataset.highlightItem === btn.id &&
          item.classList.contains('active')
        )
      );

      const nextIndex =
        direction === 'next'
          ? (index + 1) % this.buttonsArr.length
          : (index - 1 + this.buttonsArr.length) % this.buttonsArr.length;

      const target = this.buttonsArr[nextIndex];
      if (target) this.activateItem(target.id);
    }

    /* ---------------- MOBILE ---------------- */

    mobileNavigateOLD(action) {
      const wrapper = this.querySelector('.yv-images-highlights-content-mobile');
      if (!wrapper || !this.mobileItemsArr.length) return;

      const width = wrapper.offsetWidth || window.innerWidth;
      const total = this.mobileItemsArr.length;

      const next =
        action === 'next'
          ? (this.currentMobileIndex + 1) % total
          : (this.currentMobileIndex - 1 + total) % total;

      const current = this.mobileItemsArr[this.currentMobileIndex];
      const target = this.mobileItemsArr[next];

      if (current) {
        current.classList.remove('active');
        current.style.height = '';
      }

      if (target) {
        target.classList.add('active');

        const body = target.querySelector('[data-highlight-body]');
        const button = target.querySelector('button');

        if (body && button) {
          const h = body.scrollHeight + button.offsetHeight;
          target.style.height = `${h}px`;
        }
      }

      wrapper.style.transform = `translateX(${-next * width}px)`;
      this.currentMobileIndex = next;
    }

    mobileNavigate(action) {
      const wrapper = this.querySelector('.yv-images-highlights-content-mobile');
      if (!wrapper || !this.mobileItemsArr.length) return;

      const total = this.mobileItemsArr.length;

      const next =
        action === 'next'
          ? (this.currentMobileIndex + 1) % total
          : (this.currentMobileIndex - 1 + total) % total;

      const current = this.mobileItemsArr[this.currentMobileIndex];
      const target = this.mobileItemsArr[next];

      if (current) {
        current.classList.remove('active');
        current.style.height = '';
      }

      if (target) {
        target.classList.add('active');

        const body = target.querySelector('[data-highlight-body]');
        const button = target.querySelector('button');

        if (body && button) {
          const h = body.scrollHeight + button.offsetHeight;
          target.style.height = `${h}px`;
        }
      }

      // REAL SLIDE MATH
      const targetLeft = target.offsetLeft;
      wrapper.style.transform = `translateX(${-targetLeft}px)`;

      this.currentMobileIndex = next;
    }


    initMobileFirstItem() {
      const mobileWrapper = this.querySelector('.yv-images-highlights-content-mobile');
      if (!mobileWrapper || !this.mobileItemsArr.length) return;

      this.currentMobileIndex = 0;
      mobileWrapper.style.transform = 'translateX(0)';

      const wrapperWidth = mobileWrapper.offsetWidth || window.innerWidth;

      this.mobileItemsArr.forEach((item, index) => {
        const bodyInner = item.querySelector('.yv-images-highlights-body-inner');
        if (bodyInner) bodyInner.style.maxWidth = '100%';

        if (index !== 0) {
          item.classList.remove('active');
          item.style.width = '';
          item.style.height = '';
        }
      });

      const firstItem = this.mobileItemsArr[0];
      if (!firstItem) return;

      firstItem.classList.add('active');

      const body = firstItem.querySelector('[data-highlight-body]');
      const button = firstItem.querySelector('button');
      if (!body || !button) return;

      // FORCE VISIBLE FOR MEASURE (same ritual as original)
      const parent = body.parentElement;

      const original = {
        position: parent.style.position || '',
        opacity: parent.style.opacity || '',
        visibility: parent.style.visibility || ''
      };

      parent.style.position = 'static';
      parent.style.opacity = '1';
      parent.style.visibility = 'visible';
      body.style.opacity = '1';
      body.style.visibility = 'visible';

      const bodyHeight = body.scrollHeight;
      const totalHeight = bodyHeight + button.offsetHeight;

      // RESTORE
      parent.style.position = original.position;
      parent.style.opacity = original.opacity;
      parent.style.visibility = original.visibility;
      body.style.opacity = '';
      body.style.visibility = '';

      // APPLY DIMENSIONS (this was missing)
      firstItem.style.height = `${totalHeight}px`;
      firstItem.style.width = `${wrapperWidth}px`;
    }

    /* ---------------- INIT ---------------- */

    init() {
      const firstActive = this.highlightItemsArr.find(i =>
        i.classList.contains('active')
      );

      if (firstActive) {
        const id = firstActive.dataset.highlightItem;
        const content = this.contentItemsArr.find(
          i => i.dataset.highlightItemContent === id
        );

        if (content) {
          content.classList.remove('active');
          content.style.width = '';
          content.style.height = '';

          requestAnimationFrame(() => {
            const button = content.querySelector('button');
            if (!button) return;

            content.style.width = `${button.offsetWidth}px`;
            content.style.height = `${button.offsetHeight}px`;

            requestAnimationFrame(() => {
              const body = content.querySelector('.yv-images-highlights-body-inner');
              if (body) body.style.maxWidth = `${this.getDynamicMaxWidth()}px`;
              content.classList.add('active');
              this.animateItem(content);
            });
          });
        }
      }

      this.buttonsArr.forEach(btn =>
        btn.addEventListener('click', () => this.activateItem(btn.id))
      );

      this.navButtons.forEach(btn =>
        btn.addEventListener('click', e => {
          e.preventDefault();
          const action = btn.dataset.action;
          this.navigate(action);
          this.mobileNavigate(action);
        })
      );

      const wrapper = this.querySelector('.yv-images-highlights-content-mobile');
      // this.measureWhenVisible(wrapper, () => {
      //   this.initMobileFirstItem();
      // });

      this.measureWhenVisible(wrapper, () => {
        this.waitForLayout(() => {
          this.initMobileFirstItem();
        });
      });


    }
  }

  customElements.define('images-highlights', ImagesHighlights);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leia-bundles"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('leia-bundle-card')) {
  customElements.define('leia-bundle-card', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.section = this.closest('leia-gift-bundles');
      this.messages = {...this.section.querySelector('[data-messages]').dataset};
      this.messages.add = this.messages.addText;
      this.view = this;
      this.status = this.querySelector('[data-status]');
      this.cartLink = this.querySelector('[data-cart-link]');
      this.root = (this.section.dataset.root || '/').replace(/\/?$/, '/');
      this.onChange = event => {
        if (this.busy || this.locked) return;
        if (event.target.matches('[data-main-variant], [data-gift]')) this.update();
      };
      this.onClick = event => { if (event.target.closest('[data-add]')) this.addBundle(); };
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.update();
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
      this.ready = false;
    }
    selection() {
      return { main: this.view.querySelector('[data-main-variant]')?.selectedOptions[0], gift: this.view.querySelector('[data-gift]:checked'), button: this.view.querySelector('[data-add]') };
    }
    update() {
      const {main, gift, button} = this.selection();
      const available = main?.dataset.available === 'true' && gift && !gift.disabled && main.value !== gift.value;
      button.disabled = !available || button.dataset.enabled !== 'true' || this.busy || this.locked;
      button.textContent = available ? this.messages.add : this.messages.unavailable;
      this.view.querySelector('[data-total]').textContent = main?.dataset.price || '';
      const price = this.view.querySelector('[data-main-price]');
      if (price) price.textContent = main?.dataset.price || '';
      const summary = [main?.dataset.name, gift && [gift.dataset.name, gift.dataset.variantTitle].filter(Boolean).join(' · ')].filter(Boolean).join(' + ');
      this.view.querySelector('[data-summary]').textContent = summary;
      const photo = this.view.querySelector('.lgb-product-image');
      if (photo && main?.dataset.image) { photo.removeAttribute('srcset'); photo.src = main.dataset.image; }
      const details = this.view.querySelector('[data-product-link]');
      if (details && main) { const url = new URL(details.href); url.searchParams.set('variant', main.value); details.href = url.href; }
    }
    async request(path, body) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 18000);
      try {
        const response = await fetch(this.root + path, {
          method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
          headers: { Accept: 'application/json', ...(body ? {'Content-Type': 'application/json'} : {}) },
          ...(body ? {body: JSON.stringify(body)} : {})
        });
        const data = await response.json();
        if (!response.ok) { const error = new Error(typeof data.description === 'string' ? data.description : this.messages.error); error.rejected = response.status >= 400 && response.status < 500; throw error; }
        return data;
      } finally { clearTimeout(timeout); }
    }
    async removeAttempt(token) {
      const cart = await this.request('cart.js');
      const lines = cart.items.filter(item => item.properties?._leia_bundle_attempt === token);
      if (lines.length) {
        // Keys, rather than variant IDs, preserve any older cart lines for the same product.
        await this.request('cart/update.js', {updates: Object.fromEntries(lines.map(item => [item.key, 0]))});
      }
      const checked = await this.request('cart.js');
      if (checked.items.some(item => item.properties?._leia_bundle_attempt === token)) throw new Error('Cart cleanup incomplete');
    }
    async addBundle() {
      if (this.busy || this.locked) return;
      const {main, gift, button} = this.selection();
      if (button.disabled || !main || !gift) return;
      if (this.section.dataset.editor === 'true') { this.status.textContent = this.messages.editor; return; }
      // Shared lock prevents two copies of this section adding concurrently in one page.
      if (window.leiaBundleCartBusy) return;
      window.leiaBundleCartBusy = true;
      this.busy = true;
      const enabledControls = [...this.querySelectorAll('select, input, button')].filter(e => !e.disabled);
      enabledControls.forEach(e => e.disabled = true);
      button.textContent = this.messages.adding;
      this.status.textContent = '';
      this.cartLink.hidden = true;
      const token = window.crypto?.randomUUID?.() || Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
      let attempted = false;
      let addConfirmed = false;
      let discountFailure = false;
      try {
        attempted = true;
        await this.request('cart/add.js', {items: [
          {id: main.value, quantity: 1, properties: {_leia_bundle_attempt: token, _leia_bundle_role: 'product'}},
          {id: gift.value, quantity: 1, properties: {_leia_bundle_attempt: token, _leia_bundle_role: 'gift'}}
        ]});
        addConfirmed = true;
        const cart = await this.request('cart.js');
        const lines = cart.items.filter(item => item.properties?._leia_bundle_attempt === token);
        const giftLines = lines.filter(item => String(item.variant_id) === gift.value && item.properties?._leia_bundle_role === 'gift');
        const mainLines = lines.filter(item => String(item.variant_id) === main.value && item.properties?._leia_bundle_role === 'product');
        const giftFree = giftLines.reduce((n, item) => n + item.quantity, 0) === 1 && giftLines.every(item => item.final_line_price === 0);
        const mainAdded = mainLines.reduce((n, item) => n + item.quantity, 0) === 1;
        if (!giftFree || !mainAdded) { discountFailure = true; throw new Error(this.messages.discount); }
        this.locked = true;
        window.location.assign(this.section.dataset.cart);
        return;
      } catch (error) {
        let cleaned = !attempted;
        if (attempted) {
          try { await this.removeAttempt(token); cleaned = true; } catch (_) { cleaned = false; }
        }
        this.cartLink.hidden = false;
        if (!cleaned || (!addConfirmed && !error.rejected)) {
          this.locked = true;
          this.status.textContent = this.messages.uncertain;
        } else {
          this.status.textContent = discountFailure ? this.messages.discount : error.rejected ? error.message : this.messages.error;
        }
      } finally {
        window.leiaBundleCartBusy = false;
        this.busy = false;
        if (!this.locked) enabledControls.forEach(e => e.disabled = false);
        this.update();
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('leia-video-with-text')) {
  customElements.define('leia-video-with-text', class extends HTMLElement {
    connectedCallback() {
      this.startTimer = setTimeout(() => this.init(), 0);
    }
    disconnectedCallback() {
      clearTimeout(this.startTimer);
      this.observer?.disconnect();
      this.events?.abort();
      this.video?.pause();
    }
    init() {
      this.events?.abort();
      this.observer?.disconnect();
      this.events = new AbortController();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.iframe = this.querySelector('iframe.lvwt-embed');
      if (this.iframe) { this.initExternal(); return; }
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('.lvwt-toggle');
      if (!this.video || !this.toggle) return;
      const options = {signal:this.events.signal};
      const adaptFrame = () => {
        if (this.dataset.adapt === 'true' && this.video.videoWidth && this.video.videoHeight) {
          this.querySelector('.lvwt-frame').style.paddingBottom = (100 * this.video.videoHeight / this.video.videoWidth) + '%';
        }
      };
      this.video.addEventListener('loadedmetadata', adaptFrame, options);
      adaptFrame();
      this.video.controls = this.dataset.controls === 'true';
      this.toggle.hidden = this.video.controls;
      this.userPaused = false;
      this.autoPaused = false;
      this.inView = false;
      this.autoplayTried = false;
      this.video.addEventListener('play', () => {
        this.userPaused = false;
        this.autoPaused = false;
        this.updateButton();
      }, options);
      this.video.addEventListener('pause', () => {
        if (!this.autoPaused) this.userPaused = true;
        this.updateButton();
      }, options);
      this.video.addEventListener('ended', () => {
        this.userPaused = true;
        this.updateButton();
      }, options);
      this.toggle.addEventListener('click', () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.video.play().catch(() => { this.video.controls = true; this.toggle.hidden = true; });
        } else {
          this.autoPaused = false;
          this.userPaused = true;
          this.video.pause();
        }
      }, options);
      this.reducedMotion.addEventListener('change', () => {
        if (this.reducedMotion.matches) { this.userPaused = true; this.video.pause(); }
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pauseOffscreen();
        else this.tryAutoplay();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        if (this.inView) this.tryAutoplay();
        else this.pauseOffscreen();
      }, {threshold:0});
      this.observer.observe(this);
      this.updateButton();
    }
    initExternal() {
      // Keep the providers' own controls and thumbnail; no third-party SDK is needed.
      const load = () => {
        if (this.iframe.getAttribute('src')) return;
        const url = new URL(this.iframe.dataset.src);
        const autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion.matches;
        url.searchParams.set('autoplay', autoplay ? '1' : '0');
        url.searchParams.set(this.dataset.provider === 'vimeo' ? 'muted' : 'mute', this.dataset.muted === 'true' || autoplay ? '1' : '0');
        if (this.dataset.provider === 'vimeo') {
          try {
            const shared = new URL(this.dataset.externalUrl);
            const parts = shared.pathname.split('/').filter(Boolean);
            let hash = shared.searchParams.get('h');
            if (!hash && /^\d+$/.test(parts[0]) && /^[a-zA-Z0-9]+$/.test(parts[1] || '')) hash = parts[1];
            if (hash) url.searchParams.set('h', hash);
          } catch (_) { /* Public links do not need a privacy hash. */ }
        }
        this.iframe.src = url.href;
      };
      this.observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) { load(); this.observer.disconnect(); }
      }, {rootMargin:'0px'});
      this.observer.observe(this);
      this.reducedMotion.addEventListener('change', () => {
        if (this.reducedMotion.matches && this.iframe.getAttribute('src')) {
          const url = new URL(this.iframe.src);
          url.searchParams.set('autoplay', '0');
          this.iframe.src = url.href;
        }
      }, {signal:this.events.signal});
    }
    updateButton() {
      const paused = this.video.paused;
      this.toggle.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.toggle.querySelector('.lvwt-play-icon').toggleAttribute('hidden', !paused);
      this.toggle.querySelector('.lvwt-pause-icon').toggleAttribute('hidden', paused);
    }
    pauseOffscreen() {
      if (!this.video.paused) { this.autoPaused = true; this.video.pause(); }
    }
    tryAutoplay() {
      if (this.dataset.autoplay !== 'true' || this.reducedMotion.matches || document.hidden || !this.inView || this.userPaused) return;
      if (this.autoplayTried && !this.autoPaused) return;
      this.autoplayTried = true;
      this.video.muted = true;
      this.video.play().catch(() => { this.autoPaused = false; this.updateButton(); });
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
